"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _streamRecordStatus["default"];
  }
});
var _streamRecordStatus = _interopRequireDefault(require("./streamRecordStatus"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }